export type RunStatus = 'idle' | 'playing' | 'ended';

export const canReceiveDamage = (status: RunStatus, paused: boolean): boolean =>
  status === 'playing' && !paused;

export const isPlayerTargetable = (health: number, paused: boolean): boolean =>
  health > 0 && !paused;
